[
  {
    "_note": "AI personalities (ADR-0053). Each is a set of multipliers on rules.ai weights — 1.0 is unchanged, so a personality only says how it differs. Every key must name a numeric rules.ai weight; the loader checks. Each civilisation leans to one in civilizations.json; a game may give it another (ai.personalityTwist).",
    "key": "builder",
    "name": "Builder",
    "summary": "Grows tall: farms, roads and fine cities before armies.",
    "weights": {
      "demandChance": 0.6,
      "buildingBase": 1.2,
      "buildingGrowthWeight": 1.4,
      "buildingProductionWeight": 1.4,
      "buildingSizeCapWeight": 1.5,
      "buildingCultureWeight": 1.5,
      "wonderCivShare": 1.3,
      "workerValue": 1.3,
      "workerPerCityBonus": 1.3,
      "settlerValue": 0.85,
      "warStrengthRatio": 1.35,
      "warChancePerTurn": 0.35,
      "techGrowthWeight": 1.5,
      "warEarliestTurn": 1.4,
      "warPrepBonus": 0.25
    }
  },
  {
    "key": "expansionist",
    "name": "Expansionist",
    "summary": "Spreads fast: settles every good valley and sends ships to find more.",
    "weights": {
      "openBordersValue": 1.3,
      "settlerValue": 1.3,
      "settlerPerCityPenalty": 0.75,
      "scoutValue": 1.4,
      "seaScoutValue": 1.4,
      "exploreSearchRadius": 1.3,
      "settleSearchRadius": 1.25,
      "buildingBase": 0.9,
      "techGrowthWeight": 1.3
    }
  },
  {
    "key": "militarist",
    "name": "Militarist",
    "summary": "Builds big armies and is quick to war when it has the edge.",
    "weights": {
      "demandChance": 2.5,
      "openBordersValue": 0.3,
      "allianceValue": 1.3,
      "defenderValue": 1.25,
      "defenderPerUnitPenalty": 0.7,
      "unitStrengthWeight": 1.3,
      "warUnitBonus": 1.3,
      "warStrengthRatio": 0.8,
      "warChancePerTurn": 2.0,
      "warEarliestTurn": 0.7,
      "attackMinimumOdds": 0.9,
      "buildingVeteranWeight": 1.8,
      "techMilitaryWeight": 1.8,
      "buildingBase": 0.9,
      "stalemateTurns": 1.5,
      "warAims": 1.5,
      "warPrepBonus": 2.5
    }
  },
  {
    "key": "scientist",
    "name": "Scientist",
    "summary": "Prizes learning: libraries and scholars first, wars only when pressed.",
    "weights": {
      "offerChance": 1.3,
      "demandChance": 0.5,
      "buildingScienceWeight": 2.0,
      "techScienceWeight": 1.8,
      "warStrengthRatio": 1.3,
      "warChancePerTurn": 0.3,
      "defenderPerUnitPenalty": 1.15,
      "stalemateTurns": 0.7,
      "warEarliestTurn": 1.4,
      "warPrepBonus": 0.25
    }
  },
  {
    "key": "trader",
    "name": "Trader",
    "summary": "Follows the money: markets, harbours and roads, and peace that keeps them busy.",
    "weights": {
      "offerChance": 1.6,
      "openBordersValue": 1.6,
      "demandChance": 0.5,
      "buildingGoldWeight": 2.0,
      "techGoldWeight": 1.8,
      "roadValue": 1.5,
      "seaScoutValue": 1.3,
      "warChancePerTurn": 0.35,
      "upgradeReserve": 0.8,
      "stalemateTurns": 0.6,
      "warEarliestTurn": 1.4,
      "warPrepBonus": 0.25
    }
  }
]
